import { FC, JSX } from 'react'

import { SensitiveData } from '@ui/Privacy/SensitiveData'
import { Body1, Body2 } from '@ui/Typography/Typography'

import { Box } from '@shared/components/Box'

interface Props {
  statuses?: {
    badge: JSX.Element
    title: string
    description?: string
  }[]
}

export const ModalBodyStatus: FC<Props> = ({ statuses }) => (
  <Box flex direction='column' gap='x24'>
    {statuses?.map(({ badge, title, description }) => (
      <SensitiveData>
        <Box flex direction='column' gap='x6'>
          <Box flex gap='x8' align='center'>
            {badge}
            <Body2 medium color='text-med-em'>
              {title}
            </Body2>
          </Box>
          <Body1 color='text-med-em'>{description}</Body1>
        </Box>
      </SensitiveData>
    ))}
  </Box>
)
